<div>
  <m-accordion
    (onOpen)="isAccordionClicked(true)"
    (onClose)="isAccordionClicked(false)"
    id="accordion">
    <m-accordion-panel
      [header]="
        accordionData?.label ||
        accordionItems?.label ||
        accordionWithComponent?.label
      "
      [styleClass]="
        accordionData?.styleClass ||
        accordionItems?.styleClass ||
        accordionWithComponent?.styleClass ||
        ''
      "
      [active]="accordionData?.isOpen || accordionWithComponent?.isOpen"
      id="accordionTab">
      <div *ngIf="accordionItems">
        <div
          class="{{ accordionItems.literalId }}"
          *ngFor="let item of accordionItems.elements"
          [ngSwitch]="item.layoutType">
          <div>
            <portal-native-sections-template
              [item]="item"
              [fieldDefinitions]="fieldDefinitions"
              [filters]="filters">
            </portal-native-sections-template>
          </div>
        </div>
      </div>
      <div id="accordion-data" *ngIf="accordionData?.data.trim().length > 0">
        {{ accordionData.data }}
      </div>
      <ng-template portalAccordion></ng-template>
    </m-accordion-panel>
  </m-accordion>
</div>
